import { useEffect } from "react";
import { useAppSelector } from "../../../../common/hooks/hooks";
import { selectCategoryTree } from "../productSelectors";
import { findCategoryInTree } from "../helpers/categoryTreeHelpers";

/**
 * Dynamically updates the browser's <title> tag when the user changes primary filters (like category)
 * without refreshing the page.
 */
export const useSyncSeoTags = () => {
  const filters = useAppSelector((state) => state.product.filters);
  const categoryTree = useAppSelector(selectCategoryTree);

  useEffect(() => {
    // We only update if a SINGLE category is selected.
    // If multiple are selected, we fallback to the default title.
    if (filters.category.length === 1 && categoryTree.length > 0) {
      const activeCatId = filters.category[0];
      const category = findCategoryInTree(activeCatId, categoryTree);

      if (category) {
        // Fetch site name from global variables
        const siteName = window.commonVariables?.siteName || "Store";

        // Update the document title dynamically
        // Note: For a perfect match, you could pass the SEO Template string to window.commonVariables
        // and parse it here. But simple "Category | Site Name" is perfect for the browser tab.
        document.title = `${category.name} | ${siteName}`;
      }
    }
    // If no category is selected, or multiple are selected, we could revert to the base Shop title
    else if (filters.category.length === 0) {
      const siteName = window.commonVariables?.siteName || "Store";
      // You might want to pass the translated "Shop" word via commonVariables as well
      document.title = `Mağaza | ${siteName}`;
    }
  }, [filters.category, categoryTree]);
};
